import React from "react";
import PasswordResetConfirm from "../components/PasswordReset/PasswordResetConfirm";

function PasswordResetConfirmScreen() {
  return (
    <div>
      <PasswordResetConfirm />
    </div>
  );
}

export default PasswordResetConfirmScreen;